'use client';

import { InputField } from '@tuic/web-compositions/core/InputField';
import { formInputField } from '@lib/form/helper';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { FC, ReactNode } from 'react';

export type ManifestInputFieldProps = {
  field: AnyFieldApi;
  label?: ReactNode;
  note?: ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  type?: 'text' | 'email' | 'number' | 'tel' | 'url' | 'password';
  placeholder?: string;
  autoComplete?: string;
};

export const ManifestInputField: FC<ManifestInputFieldProps> = ({
  field,
  label,
  note,
  required,
  disabled,
  className,
  type,
  placeholder,
  autoComplete,
}) => (
  <InputField
    {...formInputField(field)}
    label={label}
    note={note}
    required={required ? 'label' : undefined}
    disabled={disabled}
    className={className}
    type={type}
    placeholder={placeholder}
    autoComplete={autoComplete}
  />
);
